// extracted by mini-css-extract-plugin
export default {"app":"jaS_UH_yG5ytxggDRpN7"};